import { NonIdealState } from "@blueprintjs/core";
import React from "react";

import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { CarouselView } from "common/views/carousel/Carousel.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import ImageSliderConfig from "./ImageSliderConfig";

@Panel({ id: "imageSlider", configClass: ImageSliderConfig })
export class RecommendedPanel extends React.PureComponent<IPanelProps<ImageSliderConfig>> {

	public render() {
		const { config } = this.props;

		if (isEmpty(config.urls)) {
			return (
				<NonIdealState
					title=""
					description="Configure image urls"
				/>
			);
		}
		const items = config.urls.map(this.renderImages);
		return (
			<CarouselView key="carousel" viewKey="carousel" items={items} />
		);
	}

	private renderImages = (imageUrl: string) => {
		const { config } = this.props;
		const style = { width: config.width, height: config.height };

		return (
			<div>
				<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-primary" key="card-primary">
				</BlockView>

				<ImageView key="thumbnail" style={{ ...style }}
					variant={ImageVariant.BANNER}
					src={imageUrl} viewKey="thumbnail" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/imageSlider/ImageSlider.panel.tsx